import { render, staticRenderFns } from "./VersionCard.vue?vue&type=template&id=75a8083c&scoped=true"
import script from "./VersionCard.vue?vue&type=script&lang=js"
export * from "./VersionCard.vue?vue&type=script&lang=js"
import style0 from "./VersionCard.vue?vue&type=style&index=0&id=75a8083c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a8083c",
  null
  
)

export default component.exports